
import { LoginService } from 'src/app/core/services/login';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse, HttpHandler, HttpEvent, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export class JwtInterceptor implements HttpInterceptor {

    public constructor(public loginService: LoginService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Nunca inyectar auth/rewriting en peticiones a assets locales (i18n, iconos, JSON públicos).
        // Admitimos las variantes habituales de prefijo para que TranslateHttpLoader
        // (configurado como './assets/i18n/') no quede atrapado por el interceptor.
        if (this.isLocalAssetRequest(request.url)) {
            return next.handle(request);
        }

        const token: string = this.loginService.getToken();

        if (token) {
            if (this.loginService.isTokenExpired()) {
                if (!this.loginService.isLoggingOut) {
                    console.warn('[JwtInterceptor] Token expirado detectado antes de enviar petición.');
                    this.loginService.logout(true);
                }
                // Propagamos un error 401 en lugar de EMPTY para que los callers
                // (incluido ngx-translate y cualquier subscribe con finalize) puedan
                // cerrar su ciclo de carga y no queden en limbo.
                return throwError(() => new HttpErrorResponse({
                    status: 401,
                    statusText: 'Session expired',
                    url: request.url,
                }));
            }
            request = request.clone({ headers: request.headers.set('Authorization', token) });
        }

        if (environment.domain)
            request = request.clone({ headers: request.headers.set('Domain', environment.domain) })

        if (
            request.url.indexOf('i18n') < 0
            && request.url.indexOf('icons') < 0
            && request.url.indexOf('blob') < 0
            && request.url.indexOf('googleapis') < 0
            && request.url.indexOf('url(') < 0
            && request.url.indexOf('json') < 0
        ) {
            request = request.clone({ url: environment.apiUrl + request.url })
        }

        request = request.clone({
            headers: request.headers
                .set('Accept', '*/*')
                .set('Access-Control-Allow-Origin', '*')
                .set('Access-Control-Allow-Headers', 'Authorization, Expires, Pragma, DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range'),
        });

        if (request.method === 'GET') {
            const customRequest = request.clone({
                headers: request.headers
                    .set('Cache-Control', 'no-cache')
                    .set('Pragma', 'no-cache')
            });
            return next.handle(customRequest);
        }

        return next.handle(request);
    }

    /**
     * Detecta peticiones a assets empaquetados con la app que deben saltarse el auth.
     * Incluye i18n (./assets/i18n/xx.json), iconos y otros JSON estáticos.
     */
    private isLocalAssetRequest(url: string): boolean {
        if (!url) return false;
        return (
            url.startsWith('assets/') ||
            url.startsWith('./assets/') ||
            url.startsWith('/assets/') ||
            url.includes('/assets/i18n/') ||
            url.includes('./assets/i18n/')
        );
    }
}
